<template>
  <authorized-col-layout>
    <template v-slot:header>
      <ui-heading back>
        <span v-if="action=='create'">
          {{ $t('views.settings.workspaceCreate') }}
        </span>
        <span v-if="action=='edit'">
          {{ $t('views.settings.workspaceEdit') }}
        </span>
      </ui-heading>
    </template>

    <template v-slot:left>
      <settings-navigation v-if="!$isMobile()" />
    </template>

    <template v-slot:right>

      <!-- workspace edit form -->
      <ui-page-section-box tight>
        <ui-loader v-if="loading" />
        <ui-form
          v-if="!loading"
          @submit="save()"
          :showError="v$.item.$error"
          :errorText="formErrorReason"
          class="py-4 sm:py-7 px-4 sm:px-6"
        >
          <ui-form-input
            v-model:value="item.name"
            :labelText="$t('views.settings.workspaceName')"
            id="name"
            :required="true"
          ></ui-form-input>

          <ui-form-html-editor
            :labelText="$t('views.settings.workspaceDescription')"
            v-model:value="item.public_description"
          />

          <ui-form-input
            class="mt-8"
            id="public_website_url"
            :labelText="$t('views.settings.workspaceWebsiteURL')"
            v-model:value="item.public_website_url"
            :placeholder="$t('views.settings.workspaceWebsiteURLPlaceholder')"
          />

          <div v-if="action=='edit'">
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-400 leading-7 cursor-pointer select-none">
              {{ $t('views.settings.workspaceAvatar') }}
            </label>

            <div
              class="
                flex justify-center shrink-0
                w-48 h-48
                p-2
                bg-gray-100 dark:bg-gray-900
                border border-gray-200 dark:border-gray-700 hover:border-black-900 dark:hover:border-gray-300
                rounded-sm
                cursor-pointer"
              @click.stop="openAvatarDialog()"
            >
              <img v-if="item.avatar" ref="avatarImage" class="w-48" />
              <img v-else src="data:image/svg+xml;base64,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" class="m-6 opacity-60"/>
            </div>
          </div>

          <div v-if="action=='edit'">
            <ui-button-switch
              id="is_public"
              v-model:value="item.is_public"
              :text="$t('views.settings.workspaceIsPublic')"
            />
            <transition name="layoutTransition" appear>
              <div v-if="item.is_public" class="space-y-6 mt-4">
                <div>
                  <div class="block text-sm font-medium text-gray-700 dark:text-gray-400 leading-7 cursor-pointer select-none">
                    {{$t('views.settings.workspacePublicUrl')}}
                  </div>
                  <a :href="$store.getters['account/groupPublicURLByGroupId'](id)" target="_blank" class="text-sm font-normal underline">{{ $store.getters['account/groupPublicURLByGroupId'](id) }}</a>
                </div>
              </div>
            </transition>
          </div>

          <!-- advanced settings -->
          <div class="border-t border-b border-gray-200 pb-4" v-if="action == 'edit' && item?.settings">
            <div class="font-bold mt-4">{{ $t('views.settings.workspaceAdvancedSettingsTitle') }}</div>
            <ui-button-switch
              id="is_public"
              v-model:value="item.settings.print_queue_enabled"
              :text="$t('views.settings.workspaceAdvancedEnablePrintQueue')"
            />
          </div>

          <div class="pt-8">
            <ui-button @click.stop="close()" color="default" class="mr-4">
              {{ $t('views.settings.cancel') }}
            </ui-button>
            <ui-button @click.stop="save()" color="primary">
              {{ $t('views.settings.save') }}
            </ui-button>
          </div>
        </ui-form>
      </ui-page-section-box>

      <!-- users list -->
      <ui-page-section-box tight v-if="!loading && action == 'edit'">
        <div class="text-right pt-6 mr-6 md:float-right">
          <ui-button @click.stop="openInviteUserDialog()" color="primary" small>
            {{ $t('views.settings.workspaceUserInvite') }}
          </ui-button>
          <ui-button @click.stop="$router.push({ name: 'SettingsWorkspaceInviteUsers', params: { id: item.id } });" color="default" small class="ml-2">
            {{ $t('views.settings.workspaceUserInviteBulk') }}
          </ui-button>
        </div>
        <ui-heading class="pl-4 sm:px-6" secondary>
          {{ $t('views.settings.workspaceUsers') }}
        </ui-heading>
        <ui-grid :loading="false">
          <ui-grid-item
            v-for="( user ) in item.users"
            :key="user.userId"
          >
            <ui-grid-item-col type="main">
              <ui-grid-item-col>
                <ui-grid-item-col-content type="heading">
                  {{ user.email }}
                </ui-grid-item-col-content>
                <ui-grid-item-col-content type="text">
                  {{ $t('views.settings.workspaceUsersRole') }}: {{ user.role }}
                </ui-grid-item-col-content>
              </ui-grid-item-col>
            </ui-grid-item-col>

            <ui-grid-item-col type="right-action">
              <ui-grid-item-col-content>
                <ui-button
                  @click.stop="showItemContextMenu(user.userId)"
                  icon="dots-vertical"
                  color="clear"
                ></ui-button>
                <ui-context-menu
                  :mobileTitle="user.email"
                  :show="contextMenuItemId == user.userId"
                  @close="showItemContextMenu(null)"
                  data-title="Workspace Settings: User"
                >
                  <ui-context-menu-item @click.stop="openChangeRoleDialog(user)">
                    {{ $t('views.settings.workspaceUserRoleChange') }}
                  </ui-context-menu-item>
                  <ui-context-menu-item @click.stop="openDeleteUserDialog(user)">
                    {{ $t('views.settings.workspaceUserDelete') }}
                  </ui-context-menu-item>
                </ui-context-menu>
              </ui-grid-item-col-content>
            </ui-grid-item-col>

          </ui-grid-item>
        </ui-grid>
      </ui-page-section-box>

      <!-- pending invitations -->
      <ui-page-section-box tight v-if="!loading && action == 'edit' && item?.pendingInvitations?.length > 0">
        <ui-heading class="pl-4 sm:px-6" secondary>{{ $t('views.settings.workspaceInvitationsPending') }}</ui-heading>
        <ui-grid :loading="false">
          <ui-grid-item
            v-for="( invitation ) in item.pendingInvitations"
            :key="invitation.email"
          >
            <ui-grid-item-col type="main">
              <ui-grid-item-col>
                <ui-grid-item-col-content type="heading">{{ invitation.email }}</ui-grid-item-col-content>
                <ui-grid-item-col-content type="text" class="space-x-1">
                  <div>{{ $t('views.settings.workspaceUsersRole') }}: {{ invitation.role }},</div>
                  <div>{{ $t('views.settings.workspaceInvitationCreated') }}: <time datetime="{{ invitation.createdOn }}">{{ $filters.dateTimeFormat(invitation.createdOn) }}</time>,</div>
                  <div>{{ $t('views.settings.workspaceInvitationValid') }}: <time datetime="{{ invitation.validUntil }}">{{ $filters.dateTimeFormat(invitation.validUntil) }}</time></div>
                </ui-grid-item-col-content>
              </ui-grid-item-col>
            </ui-grid-item-col>
          </ui-grid-item>
        </ui-grid>
      </ui-page-section-box>

      <!-- change role dialog -->
      <ui-confirm-dialog
        ref="confirmChangeRoleDialog"
        :headerText="$t('views.settings.workspaceUserRoleChangeTitle')"
        :confirmBtnText="$t('views.settings.workspaceUserRoleChangeConfirm')"
        :dismissBtnText="$t('views.settings.deleteCancel')"
      >
        <p class="mb-8">
          <i18n-t keypath="views.settings.workspaceUserRoleChangeInfo">
            <strong>{{ confirmDialogUserItem.email }}</strong>
            <strong>{{ item.name }}</strong>
          </i18n-t>
        </p>
        <ui-grid :loading="false" class="mx-1 my-1">
          <!-- TODO: generate list of roles dynamically!!! -->
          <ui-grid-item @click="changeDialogSelectedRole = 'admin'">
            <ui-grid-item-col>
              <ui-grid-item-col-content type="checkbox">
                <input
                  v-model="changeDialogSelectedRole"
                  value="admin"
                  id="admin"
                  type="radio"
                  class="h-4 w-4 text-gray-700 focus:ring-red-400 border-gray-200">
              </ui-grid-item-col-content>
            </ui-grid-item-col>
            <ui-grid-item-col type="main">
              <ui-grid-item-col>
                <ui-grid-item-col-content type="heading">{{ $t('views.settings.workspaceUserRoleAdmin') }}</ui-grid-item-col-content>
              </ui-grid-item-col>
            </ui-grid-item-col>
          </ui-grid-item>
          <ui-grid-item @click="changeDialogSelectedRole = 'user'">
            <ui-grid-item-col>
              <ui-grid-item-col-content type="checkbox">
                <input
                  v-model="changeDialogSelectedRole"
                  value="user"
                  id="user"
                  type="radio"
                  class="h-4 w-4 text-gray-700 focus:ring-red-400 border-gray-200">
              </ui-grid-item-col-content>
            </ui-grid-item-col>
            <ui-grid-item-col type="main">
              <ui-grid-item-col>
                <ui-grid-item-col-content type="heading">{{ $t('views.settings.workspaceUserRoleUser') }}</ui-grid-item-col-content>
              </ui-grid-item-col>
            </ui-grid-item-col>
          </ui-grid-item>
          <ui-grid-item @click="changeDialogSelectedRole = 'junior'">
            <ui-grid-item-col>
              <ui-grid-item-col-content type="checkbox">
                <input
                  v-model="changeDialogSelectedRole"
                  value="junior"
                  id="junior"
                  type="radio"
                  class="h-4 w-4 text-gray-700 focus:ring-red-400 border-gray-200">
              </ui-grid-item-col-content>
            </ui-grid-item-col>
            <ui-grid-item-col type="main">
              <ui-grid-item-col>
                <ui-grid-item-col-content type="heading">{{ $t('views.settings.workspaceUserRoleJunior') }}</ui-grid-item-col-content>
              </ui-grid-item-col>
            </ui-grid-item-col>
          </ui-grid-item>
          <ui-grid-item @click="changeDialogSelectedRole = 'observer'">
            <ui-grid-item-col>
              <ui-grid-item-col-content type="checkbox">
                <input
                  v-model="changeDialogSelectedRole"
                  value="observer"
                  id="observer"
                  type="radio"
                  class="h-4 w-4 text-gray-700 focus:ring-red-400 border-gray-200">
              </ui-grid-item-col-content>
            </ui-grid-item-col>
            <ui-grid-item-col type="main">
              <ui-grid-item-col>
                <ui-grid-item-col-content type="heading">{{ $t('views.settings.workspaceUserRoleObserver') }}</ui-grid-item-col-content>
              </ui-grid-item-col>
            </ui-grid-item-col>
          </ui-grid-item>
        </ui-grid>
      </ui-confirm-dialog>

      <!-- create invitation dialog -->
      <ui-confirm-dialog
        ref="confirmInviteDialog"
        :headerText="$t('views.settings.workspaceUserinviteTitle') + item?.name"
        :confirmBtnText="$t('views.settings.workspaceUserinviteConfirm')"
        :dismissBtnText="$t('views.settings.deleteCancel')"
        :autoCloseOnConfirm="false"
      >
        <p class="mb-8">
          {{ $t('views.settings.workspaceUserInviteInfo') }}
        </p>
        <ui-form
          v-if="!loading"
          @submit="$refs.confirmInviteDialog._confirm()"
          :showError="v$.inviteEmail.$error"
          :errorText="$t('views.settings.workspaceUserInviteError')"
        >
          <ui-form-input
            v-model:value="inviteEmail"
            :labelText="$t('views.settings.workspaceUserInviteEmail')"
            id="inviteEmail"
            :required="true"
          ></ui-form-input>
        </ui-form>
      </ui-confirm-dialog>

      <!-- delete user dialog -->
      <ui-confirm-dialog
        ref="confirmDeleteUserDialog"
        :headerText="$t('views.settings.workspaceUserDeleteTitle')"
        :confirmBtnText="$t('views.settings.deleteConfirm')"
        :dismissBtnText="$t('views.settings.deleteCancel')"
        :autoCloseOnConfirm="true"
      >
        <p class="mb-8">
          <i18n-t keypath="views.settings.workspaceUserDeleteInfo">
            <strong>{{ confirmDialogUserItem.email }}</strong>
            <strong>{{ item.name }}</strong>
          </i18n-t>
        </p>
      </ui-confirm-dialog>

      <!-- avatar dialog -->
      <avatar-dialog
        ref="avatarDialog"
        :groupId="id"
        @avatarUpdated="avatarUpdated"
      ></avatar-dialog>
    </template>
  </authorized-col-layout>
</template>

<style scoped>
.layoutTransition-enter-active,
.layoutTransition-leave-active { @apply transform transition ease-in duration-300; }
.layoutTransition-enter-from,
.layoutTransition-leave-to { @apply opacity-0; }
.layoutTransition-enter-to,
.layoutTransition-leave-from { @apply opacity-100; }
</style>

<script>
import AuthorizedColLayout from '@/components/layouts/AuthorizedColLayout.vue';
import uiPageSectionBox from '@/components/ui/uiPageSectionBox.vue';
import uiHeading from '@/components/ui/uiHeading.vue';
import uiGrid from '@/components/ui/uiGrid.vue';
import uiGridItem from '@/components/ui/uiGridItem.vue';
import uiGridItemCol from '@/components/ui/uiGridItemCol.vue';
import uiGridItemColContent from '@/components/ui/uiGridItemColContent.vue';
import uiButton from '@/components/ui/uiButton.vue';
import uiButtonSwitch from '@/components/ui/uiButtonSwitch.vue';
import uiContextMenu from '@/components/ui/uiContextMenu.vue';
import uiContextMenuItem from '@/components/ui/uiContextMenuItem.vue';
import uiForm from '@/components/ui/uiForm.vue';
import uiFormInput from '@/components/ui/uiFormInput.vue';
import uiLoader from '@/components/ui/uiLoader.vue';
import uiConfirmDialog from '@/components/ui/uiConfirmDialog.vue';
import uiFormHtmlEditor from '@/components/ui/uiFormHtmlEditor.vue';
import SettingsNavigation from '@/components/SettingsNavigation.vue';
import { mapActions, mapGetters } from 'vuex';
import { email, required, minLength, maxLength, url } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import AvatarDialog from '@/components/AvatarDialog.vue';

export default {
  name: 'SettingsWorkspaceAddOrEdit',

  components: {
    AuthorizedColLayout,
    uiPageSectionBox,
    uiHeading,
    uiGrid,
    uiGridItem,
    uiGridItemCol,
    uiGridItemColContent,
    uiButton,
    uiButtonSwitch,
    uiContextMenu,
    uiContextMenuItem,
    uiForm,
    uiFormInput,
    uiLoader,
    uiConfirmDialog,
    uiFormHtmlEditor,
    SettingsNavigation,
    AvatarDialog
},

  props: {
    id: {
      type: String,
      default: null,
      required: false
    },
    action: {
      type: String,
      required: true,
      validator: function (value) {
        return ['edit', 'create'].indexOf(value) !== -1;
      }
    }
  },

  data: () => ({
    item: null,
    loading: true,
    contextMenuItemId: null,
    changeDialogSelectedRole: null,
    confirmDialogUserItem: null,
    inviteEmail: null,
    formErrorReason: ''
  }),

  setup: () => ({ v$: useVuelidate() }),

  validations: () => ({
    inviteEmail: { required, email },
    item: {
      name: { required, minLength: minLength(1), maxLength: maxLength(30) },
      public_description: { maxLength: maxLength(30000) },
      public_website_url: { url, minLength: minLength(10), maxLength: maxLength(150) },
    }
  }),

  created: function() {
    this.init();
  },

  methods: {
    ...mapGetters('account', { getGroupById: 'groupById' }),
    ...mapActions('account', { updateGroup: 'updateGroup' }),
    ...mapActions('account', { createGroup: 'createGroup' }),
    ...mapActions('account', { changeUserRoleInGroup: 'changeUserRoleInGroup' }),
    ...mapActions('account', { deleteUserFromGroup: 'deleteUserFromGroup' }),
    ...mapActions('account', { reloadGroups: 'groups' }),
    ...mapActions('account', { inviteUserToGroup: 'inviteUserToGroup' }),

    async init() {
      this.loading = true;
      this.inviteEmail = null;
      this.item = {
        name: null,
        public_website_url: null,
        public_description: null,
        is_public: false,
        avatar: null
      };

      if (this.action == 'edit') {
        await this.reloadGroups();
        this.item = structuredClone(this.getGroupById()(this.id));

        // item does not exists (did user modified ID in URL?)
        if (this.item && this.item.id) {
          this.loading = false;
          if (this.item.avatar) {
            this.$nextTick(() => {
              this.$store.dispatch('account/downloadAvatarAsObjectURL', {groupId: this.item.id, filename: this.item.avatar}).then((imgDataUrl) => {
                this.$refs.avatarImage.src = imgDataUrl;
              });
            });
          }
        } else {
          this.$store.commit('app/setNotification', ({
            title: 'Workspace does not exists',
            text: 'Can\'t find requested workspace with ID: ' + this.id,
            onClose: () => {
              this.$router.push({ name: 'SettingsWorkspaces' })
            }
          }));
        }
      } else {
        this.loading = false;
      }
    },

    async save() {
      this.v$.$touch();
      if (await this.v$.item.$validate()) {
        this.loading = true;

        if (this.action == 'edit') {
          await this.updateGroup(this.item);
        } else {
          await this.createGroup({ name: this.item.name });
        }

        this.close();
      } else {
        switch(this.v$.item.$errors[0].$property) {
          case 'name':
            this.formErrorReason = this.$t('views.settings.workspaceNameInvalid');
            break;
          case 'public_website_url':
            this.formErrorReason = this.$t('views.settings.workspacePublicWebsiteUrlInvalid');
            break;
          default:
            this.formErrorReason = 'Validation error: ' + this.v$.item.$errors[0].$property + ' - ' + this.v$.item.$errors[0].$message;
        }
      }
    },

    close() {
      this.$router.push({ name: 'SettingsWorkspaces' })
    },

    showItemContextMenu(userId) {
      if (this.contextMenuItemId == userId) {
        this.contextMenuItemId = null;
      } else {
        this.contextMenuItemId = userId;
      }
    },

    async openChangeRoleDialog(user) {
      this.changeDialogSelectedRole = user.role;
      this.confirmDialogUserItem = user;
      let result = await this.$refs.confirmChangeRoleDialog.showDialog();
      if (result) {
        this.loading = true;
        await this.changeUserRoleInGroup({ groupId: this.item.id, userId: user.userId, role: this.changeDialogSelectedRole });
        this.contextMenuItemId = null;
        await this.init();
      }
    },

    async openDeleteUserDialog(user) {
      this.confirmDialogUserItem = user;
      let result = await this.$refs.confirmDeleteUserDialog.showDialog();
      if (result) {
        this.loading = true;
        await this.deleteUserFromGroup({ groupId: this.item.id, userId: user.userId });
        this.contextMenuItemId = null;
        await this.init();
      }
    },

    async openInviteUserDialog() {
      let result = await this.$refs.confirmInviteDialog.showDialog();
      if (result) {
        this.v$.$touch();  // validate
        if (this.v$.inviteEmail.$error) {
          this.openInviteUserDialog();  // keep dialog open when email not valid
        } else {
          this.$refs.confirmInviteDialog.close();  // close dialog manually
          this.loading = true;

          if (this.item.pendingInvitations.find((e) => (this.inviteEmail == e.email))) {
            this.$store.commit('app/setNotification', ({
              title: 'User already invited',
              text: 'User with provided email ' + this.inviteEmail + ' is already invited and can`t be invited again.'
            }));
          } else {
            await this.inviteUserToGroup({ groupId: this.item.id, email: this.inviteEmail });
          }
          await this.init();
          this.inviteEmail = null;
          this.v$.inviteEmail.$reset();
        }
      } else {
        this.inviteEmail = null;
        this.v$.inviteEmail.$reset();
      }
    },

    async openAvatarDialog() {
      this.$refs.avatarDialog.showDialog();
    },

    avatarUpdated(newAvatarFilename) {
      if (this.$refs?.avatarImage) {
        try {
          this.$refs.avatarImage.src = '';
        } catch {
          // sometimes value in $refs may not exists, for example in situation, when user moved on another page before avatar image was downloaded
        }
      }
      this.item.avatar = newAvatarFilename;
      this.$nextTick(() => {
        this.$store.dispatch('account/downloadAvatarAsObjectURL', {groupId: this.item.id, filename: newAvatarFilename}).then((imgDataUrl) => {
          try {
            this.$refs.avatarImage.src = imgDataUrl;
          } catch {
            // sometimes value in $refs may not exists, for example in situation, when user moved on another page before avatar image was downloaded
          }
        });
      });
    }
  }
}
</script>
